export default {
  suppliers: [],
  supplier: {},
  error: null,
  success: {},
  cities: {},
  districts: {},
  providerFields: {},
};
